module.exports = __webpack_public_path__ + "static/main_img-7025a70c060ee67da15e68cd1d76186d.jpg";